// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__U9KWS","info":"UpdateTermsInfo_info__2QiU2"};